import { render } from "./WorkflowInfo.vue?vue&type=template&id=6eb861a0&scoped=true"
import script from "./WorkflowInfo.vue?vue&type=script&lang=js"
export * from "./WorkflowInfo.vue?vue&type=script&lang=js"

import "./WorkflowInfo.vue?vue&type=style&index=0&id=6eb861a0&lang=scss&scoped=true"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb861a0"]])

export default __exports__